import { useState } from "react";
import { Share2, Check } from "lucide-react";
import { toast } from "sonner";

/**
 * A small "Share this Wink" button. Copies the wink's text (with attribution)
 * and a link to the homepage to the clipboard. Falls back to the native Web
 * Share sheet on supporting browsers when the user is on mobile.
 *
 * NOTE: Every share intentionally points to the site homepage so new visitors
 * always open the Barn Doors and experience the storybook from the beginning,
 * regardless of which chapter the sharer was on.
 */
export default function ShareWink({ text, label = "Share this Wink" }) {
  const [copied, setCopied] = useState(false);

  const share = async () => {
    const url = "https://thesaltymoo.com";
    const payload = `${text}\n\n— A Saltie Wink™ from The Salty Moo\n${url}`;

    try {
      if (
        typeof navigator !== "undefined" &&
        navigator.share &&
        /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)
      ) {
        await navigator.share({ title: "A Saltie Wink™", text: payload, url });
        return;
      }
      await navigator.clipboard.writeText(payload);
      setCopied(true);
      toast("Wink copied", {
        description: "The Saltie Wink™ is on your clipboard — go share the love.",
        duration: 3500,
      });
      setTimeout(() => setCopied(false), 2200);
    } catch {
      toast("Couldn't copy just now", {
        description: "Try selecting the quote and copying by hand.",
        duration: 3500,
      });
    }
  };

  return (
    <button
      type="button"
      onClick={share}
      data-testid="share-wink-btn"
      className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-[#F9F6F0] border border-[#A87149]/60 text-[#4B3A2F] text-xs uppercase tracking-[0.28em] hover:bg-[#F3EBDD] hover:border-[#4B3A2F] transition-colors"
    >
      {copied ? <Check size={14} /> : <Share2 size={14} />}
      {copied ? "Copied" : label}
    </button>
  );
}
